import { Box } from '@mui/material'
import AccountsIcon from '../assets/provided-icons/accounts.svg'
import DashboardIcon from '../assets/provided-icons/dashboard.svg'
import ListsIcon from '../assets/provided-icons/lists.svg'
import PipelineIcon from '../assets/provided-icons/pipeline.svg'
import SettingsIcon from '../assets/provided-icons/settings.svg'
import SupportIcon from '../assets/provided-icons/support.svg'
import React from 'react'

const ProvidedIcon = ({ Icon }) => {
  return (
    <Box sx={{ width: '30px', height: '30px' }}>
      <Icon width='100%' height='100%' />
    </Box>
  )
}

const iconPageMap = {
  '/dashboard': {
    label: 'Dashboard',
    navPath: '/dashboard/todos',
    icon: <ProvidedIcon Icon={DashboardIcon} />,
  },
  '/customers': {
    label: 'Accounts',
    navPath: '/customers',
    icon: <ProvidedIcon Icon={AccountsIcon} />,
  },

  '/cardwall': {
    label: 'Pipelines',
    navPath: '/cardwall',
    icon: <ProvidedIcon Icon={PipelineIcon} />,
  },
  '/lists': {
    label: 'Manage Lists',
    navPath: '/lists',
    icon: <ProvidedIcon Icon={ListsIcon} />,
  },
  '/support': {
    label: 'Support',
    navPath: '/support',
    icon: <ProvidedIcon Icon={SupportIcon} />,
  },
  '/settings': {
    label: 'Settings',
    navPath: '/settings/logo',
    icon: <ProvidedIcon Icon={SettingsIcon} />,
  },
}

export default iconPageMap
